import React from 'react';

import ShowOnMouseOverUnlessTour from 'components/ShowOnMouseOverUnlessTour';
import Tooltip from 'components/Tooltip';
import Button from 'kingpin/atoms/Button';

// Opens a Studio block on a dashboard or report over the whole window.
// Shows on hover, beside the block's other header buttons.
const FullscreenBlockButton = ({ onClick }: { onClick: () => void }) => (
  <ShowOnMouseOverUnlessTour>
    <div style={{ marginRight: 4 }}>
      <Tooltip content="Fullscreen" position="top">
        <Button
          type="Ghost"
          size="Small"
          icon="fullscreen"
          onClick={onClick}
          testId="studio-block-fullscreen"
        />
      </Tooltip>
    </div>
  </ShowOnMouseOverUnlessTour>
);

export default FullscreenBlockButton;
